module.exports = __webpack_public_path__ + "static/media/CDC-EN-notices-P3.4a481bac.jpg";